import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const LiveChat: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--live-chat')}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M13.5712509,5 L6.42833454,5 C5.63965178,5 5,5.64835734 5,6.4480257 L5,12.9187481 C5,13.7182091 5.63965178,14.3665665 6.42833454,14.3665665 L7.85749819,14.3665665 L7.85749819,16.538605 L10.4275054,14.3665665 L13.5712509,14.3665665 C14.3605555,14.3665665 15,13.7182091 15,12.9187481 L15,6.4480257 C15,5.64835734 14.3605555,5 13.5712509,5 Z"
      id="Combined-Shape"
    />
  </svg>
);

export default LiveChat;
